// Team name to abbreviation mapping
export const TEAM_ABBREVIATIONS: { [key: string]: string } = {
  "ARIZONA": "ARI",
  "Arizona": "ARI",
  "ATLANTA": "ATL",
  "Atlanta": "ATL",
  "BALTIMORE": "BAL",
  "Baltimore": "BAL",
  "BUFFALO": "BUF",
  "Buffalo": "BUF",
  "CAROLINA": "CAR",
  "Carolina": "CAR",
  "CHICAGO": "CHI",
  "Chicago": "CHI",
  "CINCINNATI": "CIN",
  "Cincinnati": "CIN",
  "CLEVELAND": "CLE",
  "Cleveland": "CLE",
  "DALLAS": "DAL",
  "Dallas": "DAL",
  "DENVER": "DEN",
  "Denver": "DEN",
  "DETROIT": "DET",
  "Detroit": "DET",
  "GREEN BAY": "GB",
  "Green Bay": "GB",
  "HOUSTON": "HOU",
  "Houston": "HOU",
  "INDIANAPOLIS": "IND",
  "Indianapolis": "IND",
  "JACKSONVILLE": "JAX",
  "Jacksonville": "JAX",
  "KANSAS CITY": "KC",
  "Kansas City": "KC",
  "LA CHARGERS": "LAC",
  "LA Chargers": "LAC",
  "LA RAMS": "LAR",
  "LA Rams": "LAR",
  "LAS VEGAS": "LV",
  "Las Vegas": "LV",
  "MIAMI": "MIA",
  "Miami": "MIA",
  "MINNESOTA": "MIN",
  "Minnesota": "MIN",
  "NEW ENGLAND": "NE",
  "New England": "NE",
  "NEW ORLEANS": "NO",
  "New Orleans": "NO",
  "NY GIANTS": "NYG",
  "NY Giants": "NYG",
  "NY JETS": "NYJ",
  "NY Jets": "NYJ",
  "PHILADELPHIA": "PHI",
  "Philadelphia": "PHI",
  "PITTSBURGH": "PIT",
  "Pittsburgh": "PIT",
  "SAN FRANCISCO": "SF",
  "San Francisco": "SF",
  "SEATTLE": "SEA",
  "Seattle": "SEA",
  "TAMPA BAY": "TB",
  "Tampa Bay": "TB",
  "TENNESSEE": "TEN",
  "Tennessee": "TEN",
  "WASHINGTON": "WAS",
  "Washington": "WAS"
};

// Player name to abbreviation mapping (for special cases)
export const PLAYER_ABBREVIATIONS: { [key: string]: string } = {
  "c stroud": "CJ",
  "s diggs": "DIGG",
  "r stevenson": "RST",
};

export const translateTeamToAbbr = (teamName: string, includeSpread: boolean = false): string => {
  // Trim and normalize the team name
  let normalized = teamName.trim();
  
  // Check if this is a 1H (first half) prop pick (e.g., "1H u22 1H")
  const firstHalfMatch = normalized.match(/^1H\s+([uo])(\d+(?:\.\d+)?)\s+1H$/i);
  if (firstHalfMatch) {
    const propType = firstHalfMatch[1].toLowerCase();
    return `1H${propType}`;
  }
  
  // Check if this is a player prop pick (e.g., "B Nix u209 pass" or "CMC o57 rush")
  const propMatch = normalized.match(/^(.+?)\s+([uo])(\d+(?:\.\d+)?)\s+(pass|rush|rec)$/i);
  if (propMatch) {
    const player = propMatch[1].trim();
    const propType = propMatch[2].toLowerCase();  // "u" or "o"
    
    // Check for special player abbreviation first
    const playerLower = player.toLowerCase();
    if (PLAYER_ABBREVIATIONS[playerLower]) {
      return `${PLAYER_ABBREVIATIONS[playerLower]}${propType}`;
    }
    
    // If single word (no spaces), keep full name; otherwise take initials
    const playerAbbr = player.includes(' ') 
      ? player.split(' ').map(w => w[0]?.toUpperCase() || '').join('')
      : player;
    return `${playerAbbr}${propType}`;
  }
  
  // Check if this is an over/under pick (e.g., "NE/DEN under 42 Pts" or "LAR/SEA over 47 pts")
  const overUnderMatch = normalized.match(/^(.+?)\s+(under|over)\s+(\d+\.?\d*)(?:\s*pts)?$/i);
  if (overUnderMatch) {
    const teams = overUnderMatch[1].trim();  // e.g., "NE/DEN" or "LAR/SEA"
    const type = overUnderMatch[2].toLowerCase();  // "under" or "over"
    const value = overUnderMatch[3];
    const suffix = type === 'under' ? 'u' : 'o';
    
    // Check if teams contains a "/" - if so, it's a game total with team abbreviations
    const teamParts = teams.split('/');
    if (teamParts.length === 2) {
      // Format: u46 or o46 (just the over/under with the value)
      return `${suffix}${value}`;
    }
    
    // Fallback: append u/o to the teams abbreviation
    return `${teams}${suffix}`;
  }
  
  // Extract spread if present (e.g., "LA RAMS -11" -> "LA RAMS" and "-11")
  const spreadMatch = normalized.match(/^(.+?)\s+([-+]\d+\.?\d*)$/);
  let spread = '';
  if (spreadMatch) {
    normalized = spreadMatch[1].trim();
    spread = includeSpread ? ' ' + spreadMatch[2] : '';
  }
  
  // Try exact match first (handles both cases)
  if (TEAM_ABBREVIATIONS[normalized]) {
    return TEAM_ABBREVIATIONS[normalized] + spread;
  }
  
  // Try uppercase version
  const upperCase = normalized.toUpperCase();
  if (TEAM_ABBREVIATIONS[upperCase]) {
    return TEAM_ABBREVIATIONS[upperCase] + spread;
  }
  
  // Try title case version
  const titleCase = normalized
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  if (TEAM_ABBREVIATIONS[titleCase]) {
    return TEAM_ABBREVIATIONS[titleCase] + spread;
  }
  
  // Return original if no match found
  return normalized + spread;
};
